import { getUser, SET_TOKEN, SET_ACCOUNT, getAccount, LOGIN, login, setToken, setService } from './actions';
import { getUserMe, getAccountMe, requestLogin, saveToken, removeToken, saveEditorToken } from './service';
import { User, Account, Service } from './types';
import { call, put, takeEvery, delay } from 'redux-saga/effects';

function* setTokenAndGetUser(action:any) {
	saveToken(action.payload);
}

function* loginSaga(action:any) {
	try {
		const token:string = yield call(requestLogin, action.payload);

		yield put(setToken(token));
	} catch (e) {
		yield put(login.failure(e));
		console.error(e);
	}
} 

function* setServiceSaga(action:any) {
	const { payload } = action;

	const service:Service = {
		sponsor: payload.billing.plan === 0 || payload.billing.plan === 1001 || payload.billing.plan === 1002,
		isStarter: payload.billing.plan === 0,
		isLight: payload.billing.plan === 1,
		isStandard: payload.billing.plan !== 0 && payload.billing.plan !== 1,
	}
	yield put(setService(service))
}

export function* authSaga() {
	yield takeEvery(SET_TOKEN, setTokenAndGetUser);
	yield takeEvery(LOGIN, loginSaga); // standalone only 
	yield takeEvery(SET_ACCOUNT, setServiceSaga); // standalone only 
}